import React from "react";
import { compose, withProps } from "recompose";
import { Button, ButtonGroup, Card, Checkbox, FormField, Grid, Input, List, Select, Table } from "semantic-ui-react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import styled from "styled-components";
import ReactDatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const BoldText = styled.p`
    font-weight: bold;
    width: fit-content;
    display: inline-block;
    margin: 0;
    font-size: 1.2rem;
`;

const StyledFormField = styled(FormField)`
    display: flex;
    justify-content: space-between;
`;

const ThreeStateInput = () => {
    const [value, setValue] = React.useState('yes');

    const onChange = (value) => {
        setValue(value);
    }

    return (
        <div style={{ display: 'flex', gap: '1rem' }}>
            <ButtonGroup>
                <Button
                    active={value === 'yes'}
                    onClick={() => onChange('yes')}
                    color={value === 'yes' ? 'green' : undefined}
                >Pass</Button>
                <Button
                    active={value === 'no'}
                    onClick={() => onChange('no')}
                    color={value === 'no' ? 'red' : undefined}
                >Fail</Button>
            </ButtonGroup>
            <Button
                active={value === 'na'}
                onClick={() => onChange('na')}
                color={value === 'na' ? 'blue' : undefined}
            >N/A</Button>
        </div>
    );
}

const PrototypeForm = ({
    user,
    manufacturer,
    model,
    serialNumber,
    location,
}) => {
    const [reportTypes, setReportTypes] = React.useState([]);
    const [reportType, setReportType] = React.useState('freetext');
    const [dateTime, setDateTime] = React.useState(new Date());

    const updateDateTime = (date) => {
        setDateTime(date);
    }

    return <React.Fragment>
        <Card fluid>
            <Card.Content>
                <Card.Header
                    as="h2"
                >Prototype Form</Card.Header>
            </Card.Content>
        </Card>
        <Card fluid>
            <Card.Content>
                <div>
                    THIS SECTION IS CREATED FOR TESTING PURPOSES ONLY
                </div>
                <Input
                    placeholder="Report Type Name"
                    name="reportTypeName"
                />
                <Select
                    placeholder="Report Type"
                    options={[
                        { key: 'freetext', value: 'freetext', text: 'Free Text' },
                        { key: 'yesno', value: 'yesno', text: 'Yes/No' },
                        { key: 'inout', value: 'inout', text: 'In/Out' },
                    ]}
                    onChange={(e, { value }) => setReportType(value)}
                    value={reportType}
                />
                <Button
                    onClick={() => {
                        const name = document.querySelector('input[name="reportTypeName"]').value;
                        setReportTypes((prev) => [...prev, { name, type: reportType }]);
                    }}
                >Add</Button>
                <List divided relaxed>
                    {
                        reportTypes.map((passType) => (
                            <List.Item>
                                <List.Content>
                                    <List.Header as='a'>{passType.name}</List.Header>
                                    <List.Description as='a'>{passType.type}</List.Description>
                                    <Button
                                        onClick={() => {
                                            setReportTypes((prev) => prev.filter((item) => item.name !== passType.name));
                                        }}
                                    >Remove</Button>
                                </List.Content>
                            </List.Item>
                        ))
                    }
                </List>
            </Card.Content>
        </Card>
        <Card fluid>
            <Card.Content>
                <FormField style={{ display: 'flex', gap: '1rem' }}>
                    <label>Tester's name</label>
                    <BoldText>{`${user.firstName.toUpperCase()} ${user.lastName.toUpperCase()}`}</BoldText>
                </FormField>
                <br />
                <FormField style={{ display: 'flex', gap: '1rem' }}>
                    <label>Date & Time</label>
                    <ReactDatePicker
                        name='DateTime'
                        showTimeSelect
                        dateFormat="dd/MM/yyyy HH:mm"
                        selected={dateTime}
                        onChange={updateDateTime}
                        timeFormat="HH:mm"
                    />
                </FormField>
            </Card.Content>
        </Card>
        <Card fluid>
            <Card.Content>
                <Grid columns={2}>
                    <Grid.Column>
                        <StyledFormField>
                            <label>Manufacturer</label>
                            <BoldText>{manufacturer.toUpperCase()}</BoldText>
                        </StyledFormField>
                    </Grid.Column>
                    <Grid.Column>
                        <StyledFormField>
                            <label>Model</label>
                            <BoldText>{model.toUpperCase()}</BoldText>
                        </StyledFormField>
                    </Grid.Column>
                </Grid>
                <Grid columns={2}>
                    <Grid.Column>
                        <StyledFormField>
                            <label>Serial number</label>
                            <BoldText>{serialNumber.toUpperCase()}</BoldText>
                        </StyledFormField>
                    </Grid.Column>
                    <Grid.Column>
                        <StyledFormField>
                            <label>Location</label>
                            <BoldText>{location.toUpperCase()}</BoldText>
                        </StyledFormField>
                    </Grid.Column>
                </Grid>
            </Card.Content>
        </Card>
        <Card fluid>
            <Card.Content>
                <Table celled sortable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={8}>Passes</Table.HeaderCell>
                            <Table.HeaderCell width={8}>Result</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            reportTypes.map((passType) => (
                                <Table.Row>
                                    <Table.Cell>{passType.name}</Table.Cell>
                                    <Table.Cell>
                                        {
                                            passType.type === 'freetext' && <Input placeholder="Result" />
                                        }
                                        {
                                            passType.type === 'yesno' && <ThreeStateInput />
                                        }
                                        {
                                            passType.type === 'inout' && (
                                                <div style={{ display: 'flex', gap: '1rem' }}>
                                                    <Input placeholder="In" />
                                                    <Input placeholder="Out" />
                                                </div>
                                            )
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            ))
                        }
                    </Table.Body>
                </Table>
            </Card.Content>
        </Card>
    </React.Fragment>
}

export default compose(
    hot(module),
    connect(
        ({ auth }) => ({
            user: auth.user,
        }),
    ),
    withProps(() => ({
        manufacturer: 'manufacturer',
        model: 'model',
        serialNumber: 'serialNumber',
        location: 'location',
    }))
)(PrototypeForm);
